// extracted by mini-css-extract-plugin
export default {"content":"WagonsPage_content__TAtHG"};